import { useState } from "react";
import Button from "../../../components/ui/button";
import Modal from "../../../components/ui/modal";
import ModalActions from "../../../components/ui/modal/ModalActions";

interface IFaceidDetailModalProps {
  urlImage: string;
  titleModal: string;
  onClose: () => void;
}

const FaceidViewModal = (props: IFaceidDetailModalProps) => {
  const [isImgLoading, setImgLoading] = useState(true);

  return (
    <Modal
      isOpen
      onClose={props.onClose}
      title={props.titleModal}
    >
      <div className="row">
        <div className="col-md-12 mb-3" style={{ textAlign: "center" }}>
          
          {/* Loading indicator */}
          {isImgLoading && (
            <div style={{ padding: 20 }}>
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Đang tải ảnh...</span>
              </div>
              <div style={{ marginTop: 10 }}>Đang tải ảnh...</div>
            </div>
          )}

          <img
            src={props.urlImage}
            height="500px"
            style={{
              display: isImgLoading ? "none" : "block",
              maxWidth: "100%",
              objectFit: "contain",
            }}
            onLoad={() => setImgLoading(false)}
            onError={() => setImgLoading(false)}
          />
        </div>
      </div>

      <ModalActions>
        <Button text="Base.Label.Close" onClick={props.onClose} />
      </ModalActions>
    </Modal>
  );
};

export default FaceidViewModal;
